// extracted by mini-css-extract-plugin
export var falconContainer = "_v8-2";
export var offerCenter = "_v8-0";
export var roktContainer = "_v8-1";